module.exports = __webpack_public_path__ + "img/ov5_cwn2011-0065-0006-dp1.e7fc8c49.jpg";